// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbCustom":"PropertyList-module--breadcrumb-custom--1IYX7"};